/* eslint-disable @typescript-eslint/consistent-type-assertions */
export enum userRoles {
  SUPER_ADMIN = <any>"1",
  STATE_ADMIN = <any>"2",
  DISTRICT_ADMIN = <any>"3",
  VOLUNTEER = <any>"4",
  EXTERNAL = <any>"6",
}
